import React from "react";
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import VisibilitySensor from 'react-visibility-sensor';

import Heading3 from '../titles/Heading3';
import GenericParagraph from '../paragraphs/Paragraph';

class FeatureServicesItem extends React.Component {
    constructor() {
        super();
        this.state = {
            animated : false,
            animationClasses : ['feature-left'],
        };
        this.headerVisible = this.headerVisible.bind(this);
    }

    headerVisible(isVisible) {
        if (isVisible) {
            if (!this.state.animated) {
                var elemIndex = this.props.index,
                timeDelay =+ elemIndex * 100;
                setTimeout(function() { 
                    var classes = this.state.animationClasses;
                    classes.push('animate-box');
                    classes.push('fadeInLeft');
                    classes.push('animated-fast');
                    this.setState({ animated: true, animationClasses: classes}); 
                }.bind(this), timeDelay);
            }
        }
    };
    render() {
        return (
            <VisibilitySensor partialVisibility={ true } onChange={ this.headerVisible } >
                <div className={this.state.animationClasses.join(' ')} style={ { opacity : 0 } }>
                    <span className="icon">
                        <i className={ this.props.value.icon }></i>
                    </span>
                    <div className="feature-copy">
                        <Heading3 title={ this.props.value.title } />
                        <GenericParagraph text={ this.props.value.subtitle } />
                    </div>
                </div>
            </VisibilitySensor>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(FeatureServicesItem);




// WEBPACK FOOTER //
// ./src/components/features/featureservices-item.jsx